import {Select} from 'antd';
import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconWrapper} from '../../../IconWrapper';

const {Option} = Select;

const CAMPAIGN_STATUSES = [
  {key: 'all', value: 'All'},
  {key: 'unarchived_only', value: 'Active'},
  {key: 'archived_only', value: 'Archived'},
];

export const ArchiveStateFilter = ({handleChange, archiveMode}) => {
  return (
    <Select
      maxTagCount={1}
      onChange={handleChange}
      defaultValue={archiveMode}
      style={{marginLeft: 10}}
      className="connections-page__filter-input"
      prefix={
        <IconWrapper>
          <FontAwesomeIcon icon={['fas', 'archive']} />
        </IconWrapper>
      }
    >
      {CAMPAIGN_STATUSES.map(s => (
        <Option key={s.key}>{s.value}</Option>
      ))}
    </Select>
  );
};
